import * as core from "@zod/core";
import { $ZodError } from "@zod/core";
export class ZodError extends $ZodError {
    format(mapper) {
        return core.formatError(this, mapper);
    }
    flatten(mapper) {
        return core.flattenError(this, mapper);
    }
    /** @deprecated Push directly to `.issues` instead. */
    addIssue(issue) {
        this.issues.push(issue);
    }
    /** @deprecated Push directly to `.issues` instead. */
    addIssues(issues) {
        this.issues.push(...issues);
    }
    /** @deprecated Check `err.issues.length === 0` instead. */
    get isEmpty() {
        return this.issues.length === 0;
    }
}
// /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
// export type ErrorMapCtx = core.$ZodErrorMapCtx;
